import { render, staticRenderFns } from "./DormUserMessages.vue?vue&type=template&id=314fa058&"
import script from "./DormUserMessages.vue?vue&type=script&lang=js&"
export * from "./DormUserMessages.vue?vue&type=script&lang=js&"
import style0 from "./DormUserMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DormUserMessages.vue"
export default component.exports